module.exports = __webpack_public_path__ + "static/ccxp-logo-8ac9905e2b8c681ae582ea985e043faf.png";